type ClientInfo = {
  app: 'MEM' | 'CUS' | 'TEC';
  screen: {
    viewportWidth: number;
    viewportHeight: number;
    screenWidth: number;
    screenHeight: number;
    pixelRatio: number;
  };
  connection: {
    effectiveType: string;
    downlink: number;
    rtt: number;
  };
};

export function getClientInfo(): ClientInfo {
  const navigatorInfo = navigator as any;
  const connection =
    navigatorInfo.connection || navigatorInfo.mozConnection || navigatorInfo.webkitConnection;

  return {
    app: 'MEM',
    screen: {
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      pixelRatio: window.devicePixelRatio,
    },
    connection: {
      effectiveType: connection?.effectiveType || 'Unknown',
      downlink: connection?.downlink || 0,
      rtt: connection?.rtt || 0,
    },
  };
}
